module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl3-50.87ba6068.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-C-lvl3-50.png
// module id = 3393
// module chunks = 11